import Swiper, { Pagination, Navigation } from 'swiper'

import 'swiper/swiper.scss'

interface DOMElements {
  container: HTMLElement
  sliderContainer: HTMLElement
  next: HTMLElement
  prev: HTMLElement
}

export class LatestPosts {
  private DOM: DOMElements

  constructor(container: HTMLElement) {
    this.DOM = {
      container,
      sliderContainer: container.querySelector('.js-slider-container') as HTMLElement,
      next: container.querySelector('.js-next') as HTMLElement,
      prev: container.querySelector('.js-prev') as HTMLElement
    }

    this.init()
  }

  private init() {
    Swiper.use([Pagination, Navigation])

    new Swiper(this.DOM.sliderContainer, {
      slidesPerView: 1,
      navigation: {
        prevEl: this.DOM.prev,
        nextEl: this.DOM.next
      },
      breakpoints: {
        768: {
          slidesPerView: 2
        }
      }
    })
  }
}
